<div class="alphabet-quick-search">
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, '#')">#</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'A')">A</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'B')">B</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'C')">C</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'D')">D</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'E')">E</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'F')">F</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'G')">G</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'H')">H</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'I')">I</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'J')">J</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'K')">K</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'L')">L</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'M')">M</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'N')">N</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'O')">O</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'P')">P</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'Q')">Q</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'R')">R</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'S')">S</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'T')">T</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'U')">U</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'V')">V</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'W')">W</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'X')">X</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'Y')">Y</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'Z')">Z</a> -
  <a href="#" class="alphabet-link" (click)="filterByLetter($event, 'All')">All</a>
</div>